import { IconTextFormatHeading } from '@components/icons/text-format-heading';
import { Text } from '@components/text';
import { TextField } from '@components/text-field';
import { getScopedTranslate } from '@locale/translate';

import { FieldDropzone } from './field-dropzone';
import { useTextContentActions } from './use-field-actions';

import { conditionsTab } from '../conditions-tab';
import { useFormBuilderContext } from '../context';
import { FieldEdit } from '../field-edit';
import { FieldConfig } from '../field-registry';
import { FieldSidebarLabel } from '../fields-sidebar';

type Config = FieldConfig<'heading'>;

const Display: Config['Display'] = ({ field }) => {
  return <Text font="heading1" text={field.label} />;
};

const FormBuilderHeading: Config['Component'] = ({ field, dragHandle }) => {
  const menuItems = useTextContentActions(field);
  const actions = useFormBuilderContext().store.actions;

  return (
    <FieldDropzone field={field}>
      <FieldEdit
        field={field}
        dragHandle={dragHandle}
        menu={menuItems}
        display={<Display field={field} />}
        edit={
          <TextField
            defaultValue={field.label}
            label={field.label}
            hideLabel
            onChange={actions.createChangeHandler(field, 'label')}
          />
        }
      />
    </FieldDropzone>
  );
};

const { t } = getScopedTranslate({
  en: {
    title: 'Heading',
  },
});

export const headingConfig: Config = {
  kind: 'heading',
  title: t('title'),
  group: 'content',
  Display,
  TreeDisplay: ({ field }) => <FieldSidebarLabel label={field.label} />,
  Icon: IconTextFormatHeading,
  Component: FormBuilderHeading,
  propertiesTabs: [conditionsTab],
};
